import myaxios from '@/myaxios.js'
// 定义state
const state = {
    workers: [],
    roles: []
}
// 设置state
const mutations = {
    SET_WORKERS: (state, workers) => {
        state.workers = workers
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    }
}
// 调用mutations修改 states
const actions = {
    ADD_WORKERS: function({ commit, getters }) {
        console.log(`workerslength`, state.workers.length)
        if (state.workers.length == 0) {
            return new Promise(resolve => {
                myaxios.getNoloading(`/api/AcisSystem/Worker/Items`).then((data) => {
                    let allworker = _.filter(data, d => { return !d.is_deleted && !d.is_system }).map(d => {
                        return {
                            name: d.name,
                            id: d.id,
                            abbr: d.abbr,
                            card_no: d.card_no,
                            enum_worker_role: d.enum_worker_role,
                            worker_duty: d.worker_duty,
                            section_name: d.section_name,
                            asa: d.asa,
                            enum_asa: d.enum_asa,
                            surgery_scale: d.surgery_scale,
                            enum_surgery_scale: d.enum_surgery_scale,
                            photo_name: d.photo_name,
                            dic_section_id: d.dic_section_id,
                            sectionids: d.sectionids,
                            rotation_sectionids: d.rotation_sectionids,
                            hospital_wardids: d.hospital_wardids,
                            wardids: d.wardids
                        }
                    })
                    // 调用mutations修改 states
                    commit(`SET_WORKERS`, allworker)
                    resolve(allworker)
                }).catch(error => {
                    console.log(error)
                })
            })
        }
    },
    ADD_ROLES: function({ commit, getters }) {
        myaxios.get(`/api/AcisSystem/Role/Get`).then((data) => {
            let r = _.filter(data, { is_deleted: false })
            r = _.orderBy(r, `print_order`).map(d => {
                return {
                    label: `${d.name}`,
                    value: `${d.id}`
                }
            })
            commit(`SET_ROLES`, r)
        }).catch(error => {
            console.log(error)
        })
    }
}
// 修改state
const getters = {
    workers: (state, getters) => {
        return state.workers
    },
    workers_by_duty: (state, getters) => {
        let r = state.workers.map(d => {
            return {
                label: `${d.name}`,
                value: d.id,
                jianpin: d.abbr,
                card_no: d.card_no,
                worker_duty: d.enum_worker_role == 1 ? `医生` : (d.enum_worker_role == 2 ? `护士` : ``),
                // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                code: d.section_name,
                section_name: d.section_name,
                asa: d.asa,
                surgery_scale: d.surgery_scale,
                photo_name: d.photo_name,
                dic_section_id: d.dic_section_id,
                sectionids: d.sectionids,
                rotation_sectionids: d.rotation_sectionids,
                hospital_wardids: d.hospital_wardids,
                wardids: d.wardids
            }
        })
        return _.groupBy(r, `worker_duty`)
    },
    workers_by_dutyNew: (state, getters) => {
        let r = state.workers.map(d => {
            let workerduty = d.worker_duty
            if (workerduty == `麻醉助手`) workerduty = `麻醉医生`
            else if (workerduty == `手术助手`) workerduty = `手术医生`
            else if (workerduty == `器械护士`) workerduty = `巡回护士`
            else if (workerduty == `复苏护士` || workerduty == `麻醉护士`) workerduty = `巡回护士`
            return {
                label: `${d.name}`,
                value: d.id,
                jianpin: d.abbr,
                card_no: d.card_no,
                // worker_duty: d.enum_worker_role == 1 ? `医生` : `护士`,
                worker_duty: workerduty,
                // worker_duty: d.worker_duty,
                code: d.section_name,
                section_name: d.section_name,
                asa: d.asa,
                surgery_scale: d.surgery_scale,
                photo_name: d.photo_name,
                dic_section_id: d.dic_section_id,
                sectionids: d.sectionids,
                rotation_sectionids: d.rotation_sectionids,
                hospital_wardids: d.hospital_wardids,
                wardids: d.wardids }
        })
        return _.groupBy(r, `worker_duty`)
    },
    roles: (state, getters) => {
        return state.roles
    }
}
export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sysuser.js